'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { HtmlRenderer } from '@eliadmin/core/src/components/ui/html-renderer';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export type PreparedProductHtmlEntry = { source: string; html: string };
const PreparedProductHtmlContext = createContext<PreparedProductHtmlEntry[]>([]);

export function PreparedProductHtmlProvider({ entries, children }: {
  entries: PreparedProductHtmlEntry[];
  children: ReactNode;
}) {
  return <PreparedProductHtmlContext.Provider value={entries}>{children}</PreparedProductHtmlContext.Provider>;
}

export function PreparedProductHtml({ html, className }: { html: string; className?: string }) {
  const entries = useContext(PreparedProductHtmlContext);
  const prepared = entries.find(entry => entry.source === html);
  // Authenticated revalidation or a variant may replace the text. Never display
  // a stale snapshot, trust raw HTML, or require all variant parsers on first load.
  if (!prepared) return <HtmlRenderer html={html} className={className} />;
  return (
    <div
      className={cn(
        'ea-html-renderer min-w-0 max-w-full [&_figure.table]:block [&_figure.table]:max-w-full [&_figure.table]:overflow-x-auto [&_figure.table]:overscroll-x-contain',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: prepared.html }}
    />
  );
}
